<template>
    <div class="Footer-bottom">
        <div class="Footer-bottom-item" :class="{ 'Footer-bottom-item--clickable': item.url }" @click="openUrl(item)"
            v-for="(item, index) in PublicWebData" :key="index">
            {{ item.label }}
            <template v-if="item.value">{{ item.value }}</template>
        </div>
    </div>
</template>
<script>
export default {
    name: 'FooterBottom',
    data() {
        return {
            PublicWebData: [
                {
                    label: "版权声明",
                    url: '/copyRight'
                },
                {
                    label: "公安备案号:",
                    value: "33010302003168",
                    url: "https://www.beian.gov.cn/portal/registerSystemInfo"
                },
                {
                    label: "工信部备案号:",
                    value: "浙ICP备11047044号",
                    url: "https://beian.miit.gov.cn/#/Integrated/index"
                },
                {
                    label: "出版物经营许可证:",
                    value: "浙批-300476号 "
                },
                {
                    label: "网络出版服务许可证:",
                    value: "浙-003号"
                }
            ]
        }
    },
    methods: {
        openUrl(item) {
            if (item?.url?.startsWith('http')) {
                window.open(item.url)
            } else {
                this.$router.push(item?.url)
            }
        }
    }
}
</script>


<style lang="less" scoped>

.Footer-bottom {
    width: 1200px;
    margin: 0 auto;
  }


  .Footer-bottom {
    border-top: 1px solid #E6E6E6;
    margin-top: 16px;
    padding: 16px 0;
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 14px;
    font-weight: 400;
    color: #999999;

    &-item {
      padding: 0 16px;
      position: relative;
      transition: opacity .3s;

      &--clickable {
        cursor: pointer;

        &:hover {
          opacity: .8;
        }
      }

      &:not(:last-child) {
        &::after {
          content: "";
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
          width: 1px;
          height: 14px;
          background: #E6E6E6;
        }
      }

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }
    }
  }
</style>